import { AreaInformation } from "../area/AreaInformation";
import { AreaRect } from "../area/AreaRect";
import { HGroup } from "../area/HGroup";
import { HLine } from "../area/HLine";
import { VLine } from "../area/VLine";

import { SC_Input } from "../input/SC_Input";
import { SC_Inv } from "../wr/SC_Inv";
import { RoofShape } from "../roof/RoofShape";
import { RoofType } from "../roof/RoofType";
import { SC_Beam } from "../roof/SC_Beam";

import { Sol50 } from "./Sol50";
import { Global } from "../utilities/global";
import { Statics } from "../utilities/statics";
import { ItemUtils } from "../utilities/ItemUtils";
import { Rectangle } from "../area/Rectangle";
import { Point } from "../area/Point";
import { MountingSystem } from "./MountingSystem";
import { MountingType } from "./MountingType";
import { SOL50STANDARD4m } from "./SOL50STANDARD4m";
import { SC_RoofHook } from "../stocklist/roofhook/SC_RoofHook";
import * as _ from 'lodash';
import { ModulProp } from "../panel/ModulProp";
import { Modul } from "../panel/Modul";
import { ModList } from "../panel/ModList";
import { Dyn } from "../utilities/dyn";
import { DrawRoofForPanel } from '../panel/drawRoofForPanel';
import Konva from 'konva';
import {isElementScrolledOutsideView} from "@angular/cdk/overlay/position/scroll-clip";



// 	import Point = flash.geom.Point;
// 	import Rectangle = flash.geom.Rectangle;
// 	import getTimer = flash.utils.getTimer;


// 	import ModList = panel.ModList;
// 	import Modul = panel.Modul;
// 	import ModulProp = panel.ModulProp;

// 	import Alert = mx.controls.Alert;
// 	import Label = mx.controls.Label;

// 	import RGBColor = org.alivepdf.colors.RGBColor;
// 	import SC_RoofHook = stocklist.roofhook.SC_RoofHook;

// 	import SC_Inv = wr.SC_Inv;

export class Sol50OnRoof {
	//in cm, endkappe * 2
	public static nRandLeftRight: number = 0.4;
	//in cm, endkappe
	public static nRandLeft: number = 0.2;
	//in cm, endkappe
	public static nRandRight: number = 0.2;
	//in cm, abschlussblende
	public static nRandTop: number = 4.8;
	//in cm, abschlussblende
	public static nRandBottom: number = 4.8;
	//in cm, vertical profile overlap top
	public static nVPOverLapTop: number = 5.0;
	//in cm, vertical profile overlap bottom
	public static nVPOverLapBottom: number = 5.0;
	//in cm
	public static nGroupDistance: number = 20;
	public static aHGroups: any[] = new Array();
	//horizontal profile, HProfil
	public static uiHProfileCol: string = '#808080';
	//in cm
	public static nHProfileHeight: number = 9.6;
	//Variable
	public static sHProfileVar: string;
	//Length PE
	public static nHProfileLen: number;
	//total length in cm
	public static nHProfileTotLen: number;
	//list
	private static aHProfile: any[];

	//cut profile length for profile cutting , cm
	public static cutProfileLen: number = 10;

	/* HProfil optimize and find AbschBlend
		Condition: first parameter is sorted by l (left)
	*/
	private static HProfile_optimize(aRow: any[]): void {
		var i: number, j: number;
		var hprofileTmp: HLine;
		var hprofileCur: HLine;
		var abschblendTmp: HLine;
		var nXDif: number;
		var nXTol: number;
		nXTol = Sol50.nHorizontalAbstand + Global.nModAbstTol;
		hprofileTmp = new HLine(aRow[0]);
		hprofileCur = new HLine(null);
		hprofileCur.l = hprofileTmp.l;
		hprofileCur.r = hprofileTmp.r;
		hprofileCur.y = hprofileTmp.y;
		hprofileCur.e = 0;
		Sol50OnRoof.aHProfile.push(hprofileCur);
		for (i = 1; i < aRow.length; i++) {
			hprofileTmp = aRow[i];
			if (hprofileTmp.l <= hprofileCur.r + nXTol) {
				if (hprofileTmp.r > hprofileCur.r) {
					nXDif = hprofileCur.r - hprofileTmp.l;
					if (nXDif > Global.nModAbstTol) {
						hprofileCur.e += nXDif;
					}
					hprofileCur.r = hprofileTmp.r;
				} else {
					nXDif = hprofileTmp.r - hprofileTmp.l;
					if (nXDif > Global.nModAbstTol) {
						hprofileCur.e += nXDif;
					}
				}
				//find AbschBlend
			} else {
				//next one
				hprofileCur = new HLine(null);
				hprofileCur.l = hprofileTmp.l;
				hprofileCur.r = hprofileTmp.r;
				hprofileCur.y = hprofileTmp.y;
				hprofileCur.e = 0;
				Sol50OnRoof.aHProfile.push(hprofileCur);
			}
		}
	}
	//get hprofiles in a row
	private static HProfile_getRow(aTmp: any[], iLen: number, iStart: number): any[] {
		var hprofilTmp: HLine;
		var hprofilTmp2: HLine;
		var aResult: any[];
		var i: number, j: number;
		var nYDif: number;
		if (iLen <= iStart) {
			return null!;
		}
		hprofilTmp = aTmp[iStart];
		j = 1;
		for (i = iStart + 1; i < iLen; i++) {
			hprofilTmp2 = aTmp[i];
			nYDif = hprofilTmp2.y - hprofilTmp.y;
			if (nYDif < Global.nModAbstTol && nYDif > -Global.nModAbstTol) {
				j++;
				//valid
			} else {
				break;
			}
		}
		aResult = new Array(j);
		for (i = 0; i < j; i++) {
			aResult[i] = aTmp[i + iStart];
		}
		return aResult;
	}
	//find horizontal profiles
	private static HProfile_find(): number {
		var i: number, j: number;
		var hgroupTmp: HGroup;
		var iResult: number = 0;
		var iLen: number;
		var hprofileTmp: HLine;
		var iCurrent: number;
		var aRow: any[];
		var nHalf: number;
		var aTmp: any[];
		iLen = Sol50OnRoof.aHGroups.length;
		nHalf = Sol50.nVertikalAbstand / 2;
		Sol50OnRoof.aHProfile = new Array();
		aTmp = new Array();
		//einfach alle HGroups als einzelne betrachten
		const temp = { l: 0, r: 0, y: 0 };
		for (i = 0; i < iLen; i++) {
			hgroupTmp = Sol50OnRoof.aHGroups[i];
			//oben
			let hprofileTmp = temp;
			hprofileTmp.l = hgroupTmp.x;
			hprofileTmp.r = hgroupTmp.x + hgroupTmp.width;
			hprofileTmp.y = hgroupTmp.y - nHalf;
			aTmp.push(hprofileTmp);
			//unten
			hprofileTmp = temp;
			hprofileTmp.l = hgroupTmp.x;
			hprofileTmp.r = hgroupTmp.x + hgroupTmp.width;
			hprofileTmp.y = hgroupTmp.height + hgroupTmp.y + nHalf;
			aTmp.push(hprofileTmp);
		}
		//sort by y
		// aTmp.sortOn("y", Array.NUMERIC);
		aTmp = _.sortBy(aTmp, 'y');
		iLen = aTmp.length;
		iCurrent = 0;
		while (iCurrent < iLen) {
			aRow = Sol50OnRoof.HProfile_getRow(aTmp, iLen, iCurrent);
			iCurrent += aRow.length;
			iCurrent++;
			// aRow.sortOn("l", Array.NUMERIC);
			aRow = _.sortBy(aRow, 'l');
			Sol50OnRoof.HProfile_optimize(aRow);
		}
		return iResult;
	}

	//get amount
	public static getHProfile(): number {
		var i: number;
		var nTotLen: number;
		var iResult: number;
		var hprofilTmp: HLine;
		Sol50OnRoof.HProfile_find();
		nTotLen = 0;
		for (i = 0; i < Sol50OnRoof.aHProfile.length; i++) {
			hprofilTmp = Sol50OnRoof.aHProfile[i];
			nTotLen += hprofilTmp.r - hprofilTmp.l;

		}
		nTotLen += nTotLen * Dyn.HP_PR_CO_FA;
		Sol50OnRoof.nHProfileTotLen = nTotLen;
		iResult = Math.ceil(nTotLen / Sol50OnRoof.nHProfileLen);
		return iResult;
	}
	//zeichnen
	public static drawHProfile(): void {
		var i: number;
		var hprofileTmp: HLine;
		var nHalfProfHeight: number;
		nHalfProfHeight = Sol50OnRoof.nHProfileHeight / 2; //9.6
		Sol50OnRoof.HProfile_find();
		console.log("Sol50OnRoof.aHProfile", Sol50OnRoof.aHProfile)
		for (i = 0; i < Sol50OnRoof.aHProfile.length; i++) {
			hprofileTmp = new HLine(Sol50OnRoof.aHProfile[i]);
			const top = hprofileTmp.y - nHalfProfHeight;
			var temp = new Konva.Line({
				points: [hprofileTmp.l, top, hprofileTmp.r, top, hprofileTmp.r, top - Sol50OnRoof.nHProfileHeight, hprofileTmp.l, top - Sol50OnRoof.nHProfileHeight],
				fill: Sol50OnRoof.uiHProfileCol,
				draggable: true,
				closed: true,
				name: name,
			});
			DrawRoofForPanel.layerPanel.add(temp);
			temp.draw();
			// Global.pageDesign.canFramework.graphics.beginFill(Sol50OnRoof.uiHProfileCol);808080
			// Global.pageDesign.canFramework.graphics.drawRect(hprofileTmp.l, hprofileTmp.y - nHalfProfHeight, hprofileTmp.r - hprofileTmp.l, Sol50OnRoof.nHProfileHeight);
			// Global.pageDesign.canFramework.graphics.endFill();
			if (MountingSystem.bMarkers) {
				// MountingSystem.markHLine(hprofileTmp.l, hprofileTmp.r, hprofileTmp.y, Sol50OnRoof.nHProfileLen);
			}
		}
	}
	drawHprofileKonva (obj: any) {
		var temp = new Konva.Line({
			points: [ ...obj ],
			fill: Sol50OnRoof.uiHProfileCol,
			draggable: true,
			closed: true,
			name: name,
		});
		DrawRoofForPanel.layerPanel.add(temp);
		temp.draw();
	}
	public static drawHProfilePDF(): void {
		// var i: number;
		// var hprofileTmp: HLine;
		// var nHalfProfHeight: number;
		// var rTmp: Rectangle = new Rectangle();
		// nHalfProfHeight = Sol50OnRoof.nHProfileHeight / 2;
		// Sol50OnRoof.HProfile_find();
		// for (i = 0; i < Sol50OnRoof.aHProfile.length; i++) {
		// 	hprofileTmp= new HLine(Sol50OnRoof.aHProfile[i]);
		// 	rTmp.x = hprofileTmp.l * this.SysPDF.nPdfFactor;
		// 	rTmp.y = (hprofileTmp.y - nHalfProfHeight) * this.SysPDF.nPdfFactor;
		// 	rTmp.width = (hprofileTmp.r - hprofileTmp.l) * this.SysPDF.nPdfFactor;
		// 	rTmp.height = Sol50OnRoof.nHProfileHeight * this.SysPDF.nPdfFactor;
		// 	this.SysPDF.pdfMain.beginFill(new RGBColor(Sol50OnRoof.uiHProfileCol));
		// 	this.SysPDF.pdfMain.lineStyle(new RGBColor(0x000000), 0);
		// 	this.SysPDF.pdfMain.drawRect(rTmp);
		// 	this.SysPDF.pdfMain.endFill();
		// 	if (this.SysPDF.bMarkers) {
		// 		this.SysPDF.pdfMain.addText(i.toString(), rTmp.left, rTmp.y);
		// 		this.SysPDF.markHLine(rTmp.left, rTmp.right, hprofileTmp.y * this.SysPDF.nPdfFactor, Sol50OnRoof.nHProfileLen * this.SysPDF.nPdfFactor);
		// 	}
		// }
	}
	//vertical profile
	public static uiVProfileCol: string = '#c0c0c0';
	//in cm
	public static nVProfileHeight: number = 9.6;
	//Variable
	public static sVProfileVar: string;
	//Length PE
	public static nVProfileLen: number;
	//list
	static aVProfile: any[];
	/**
	 * connect separate vertical lines in a column
	 * if lines are vertically overlapped or positioned within a tolerance
	 * @param aCol list of lines in a column, sorted by t (top)
	 *
	 */
	static VProfile_optimize(aCol: any[]): void {
		var i: number, j: number;
		var vprofileTmp: VLine;
		var vprofileCur: VLine;
		var abschblendTmp: VLine;
		var nYDif: number;
		var nYTol: number;
		nYTol = Sol50.nVertikalAbstand + Global.nModAbstTol;
		vprofileTmp = aCol[0];
		vprofileCur = new VLine(null);
		vprofileCur.t = vprofileTmp.t;
		vprofileCur.b = vprofileTmp.b;
		vprofileCur.x = vprofileTmp.x;
		Sol50OnRoof.aVProfile.push(vprofileCur);
		for (i = 1; i < aCol.length; i++) {
			vprofileTmp = aCol[i];
			if (vprofileTmp.t <= vprofileCur.b + nYTol) {
				vprofileCur.b = vprofileTmp.b;
			} else {
				//another one
				vprofileCur = new VLine(null);
				vprofileCur.t = vprofileTmp.t;
				vprofileCur.b = vprofileTmp.b;
				vprofileCur.x = vprofileTmp.x;
				Sol50OnRoof.aVProfile.push(vprofileCur);
			}
		}
	}
	/**
	 * group lines as a column using horizontal tolerance
	 * @param aTmp list of verticle lines sorted by x
	 * @param iLen line count
	 * @param iStart index of first line
	 * @return
	 *
	 */
	static VProfile_getCol(aTmp: any[], iLen: number, iStart: number): any[] {
		var vprofileTmp: VLine;
		var vprofileTmp2: VLine;
		var aResult: any[];
		var i: number, j: number;
		var nXDif: number;
		if (iLen <= iStart) {
			return null!;
		}
		vprofileTmp = aTmp[iStart];
		j = 1;
		for (i = iStart + 1; i < iLen; i++) {
			vprofileTmp2 = aTmp[i];
			nXDif = vprofileTmp2.x - vprofileTmp.x;
			if (nXDif < Global.nModAbstTol && nXDif > -Global.nModAbstTol) {
				j++;
				//valid
			} else {
				break;
			}
		}
		aResult = new Array(j);
		for (i = 0; i < j; i++) {
			aResult[i] = aTmp[i + iStart];
		}
		return aResult;
	}
	//find vertical profiles
	private static VProfile_find(): void {
		var i: number;
		var nSparrenLeft: number;
		var iSparrenIndex: number;
		var hgroupTmp: HGroup;
		var nAbstandH: number = 1; //TFE
		var nAbstandHCurrent: number;
		var nAbstandHLast: number;
		var sModWidth: string;
		var nCurrentX: number;
		var nX: number;
		var nXMax: number;
		var vprofileTmp: VLine;
		var aTmp: any[];
		var iCurrent: number;
		var iLen: number;
		var aCol: any[];
		var sRange: string;
		var iModIndex: number;
		var nModW: number, nModH: number;
		var nCurX: number, nCurY: number;
		var rTmp: Rectangle;
		var nModWSpace: number;
		var iRaftCnt: number;
		aTmp = new Array();
		for (i = 0; i < Sol50OnRoof.aHGroups.length; i++) {
			hgroupTmp = Sol50OnRoof.aHGroups[i];
			if (hgroupTmp.x < SC_Input.nBeamDist1) {
				nX = SC_Input.nBeamDist1;
				iSparrenIndex = 0;
				nCurrentX = nX;
			} else {
				nX = hgroupTmp.x - SC_Input.nBeamDist1;
				iSparrenIndex = parseInt("" + nX / SC_Input.nBeamDist) + 1;
				nCurrentX = (iSparrenIndex * SC_Input.nBeamDist) + SC_Input.nBeamDist1;
			}
			nXMax = hgroupTmp.x + hgroupTmp.width;
			rTmp = new Rectangle();
			nModH = hgroupTmp.height;
			nModW = hgroupTmp.nModWith;
			nCurY = hgroupTmp.y;
			//sparrenweise
			nModWSpace = nModW + Sol50.nHorizontalAbstand;
			sModWidth = nModW.toString();
			iRaftCnt = 0;
			nAbstandHLast = Number.MAX_VALUE;
			nAbstandHCurrent = Number.MAX_VALUE;
			while (nCurrentX < nXMax) {
				iModIndex = Math.floor((nCurrentX - hgroupTmp.x) / nModWSpace);
				rTmp.x = (iModIndex * nModWSpace) + hgroupTmp.x;
				rTmp.y = nCurY;
				rTmp.width = nModW;
				rTmp.height = nModH;
				sRange = RoofShape.getRangeByRect(rTmp);
				nAbstandH = Statics.oSpanWidthMax[sRange][sModWidth];
				if (nAbstandH == -1) {
					iRaftCnt = 0;
					nCurrentX += SC_Input.nBeamDist;
					continue;
				} else if (nAbstandH > SC_Input.nBeamDist) {
					nAbstandH = Math.floor(nAbstandH / SC_Input.nBeamDist) * SC_Input.nBeamDist;
				}
				if (nAbstandHLast == nAbstandH) {
					if (nAbstandHCurrent < nAbstandHLast) {
						nAbstandHLast = nAbstandH;
						nCurrentX += SC_Input.nBeamDist;
						nAbstandHCurrent += SC_Input.nBeamDist;
						continue;
					}
				} else if (nAbstandHLast * 2 == nAbstandH) {
					//doppelt
					if (nAbstandHCurrent < nAbstandH) {
						nAbstandHLast = nAbstandH;
						nCurrentX += SC_Input.nBeamDist;
						nAbstandHCurrent += SC_Input.nBeamDist;
						continue;
					}
				}
				nAbstandHLast = nAbstandH;
				vprofileTmp = null!;
				vprofileTmp.t = hgroupTmp.y;
				vprofileTmp.b = hgroupTmp.y + hgroupTmp.height;
				vprofileTmp.x = nCurrentX;
				aTmp.push(vprofileTmp);
				iRaftCnt++;
				nCurrentX += SC_Input.nBeamDist;
				nAbstandHCurrent = SC_Input.nBeamDist;
			}
			//letztes Modul bei doppeltem Abstand
			if (nAbstandH > SC_Input.nBeamDist && nAbstandH == nAbstandHCurrent) {
				nCurrentX -= SC_Input.nBeamDist;
				vprofileTmp = null!;
				vprofileTmp.t = hgroupTmp.y;
				vprofileTmp.b = hgroupTmp.y + hgroupTmp.height;
				vprofileTmp.x = nCurrentX;
				aTmp.push(vprofileTmp);
			}
		}
		if (aTmp.length == 0) return;
		Sol50OnRoof.aVProfile = new Array();
		//sort by x
		aTmp = _.sortBy(aTmp, 'x');
		iLen = aTmp.length;
		iCurrent = 0;
		while (iCurrent < iLen) {
			aCol = Sol50OnRoof.VProfile_getCol(aTmp, iLen, iCurrent);
			iCurrent += aCol.length;
			// aCol.sortOn("t", Array.NUMERIC);
			aCol = _.sortBy(aCol, 't');
			Sol50OnRoof.VProfile_optimize(aCol);
		}
		//correct length
		for (i = 0; i < Sol50OnRoof.aVProfile.length; i++) {
			vprofileTmp = Sol50OnRoof.aVProfile[i];
			//correct by cover trim and vertical overlap
			vprofileTmp.t -= Sol50OnRoof.nVPOverLapTop;
			vprofileTmp.b += Sol50OnRoof.nVPOverLapBottom;
		}
	}
	private static Purlin_VProfile_determineDistance(nVSize: number): number {
		var nDistBest: number = 1; //TFE
		var sPanelSize: string;
		sPanelSize = nVSize.toString();
		// nDistBest = Statics.oSpanWidthMax["f"][sPanelSize];
		if (nDistBest < 1) {
			// nDistBest = Statics.oSpanWidthMax["g"][sPanelSize];
		}
		if (nDistBest < 1) {
			// nDistBest = Statics.oSpanWidthMax["h"][sPanelSize];
		}
		if (nDistBest < 1) {
			nDistBest = 0;
		}
		return nDistBest;
	}
	private static Purlin_VProfile_find_old(): void {
		var i: number;
		var nDistLeft: number;
		var nDistBest: number = 1; //TFE
		var nDistBestCurrent: number;
		var hgroupTmp: HGroup;
		var nAbstandH: number;
		var sModWidth: string;
		var nCurrentX: number;
		var nX: number;
		var nXMax: number;
		var VProfilTmp: VLine;
		var aTmp: any[];
		var iCurrent: number;
		var iLen: number;
		var aCol: any[];
		var sRange: string;
		var iModIndex: number;
		var nModW: number, nModH: number;
		var nCurX: number, nCurY: number;
		var rTmp: Rectangle;
		var nModWSpace: number;
		aTmp = new Array();
		sModWidth = SC_Input.nModHeight.toString();
		// nDistBest = Statics.oSpanWidthMax["f"][sModWidth];
		if (nDistBest < 1) {
			// nDistBest = Statics.oSpanWidthMax["g"][sModWidth];
		}
		if (nDistBest < 1) {
			// nDistBest = Statics.oSpanWidthMax["h"][sModWidth];
		}
		if (nDistBest < 1) {
			return;
		}
		for (i = 0; i < Sol50OnRoof.aHGroups.length; i++) {
			hgroupTmp = new HGroup(Sol50OnRoof.aHGroups[i]);
			nXMax = hgroupTmp.x + hgroupTmp.width;
			nModH = hgroupTmp.height;
			nModW = hgroupTmp.nModWith;
			nCurY = hgroupTmp.y;
			nModWSpace = nModW + Sol50.nHorizontalAbstand;
			nDistBest = Sol50OnRoof.Purlin_VProfile_determineDistance(nModH);
			if (nDistBest == 0) {
				return;
			}
			nDistBestCurrent = nDistBest;
			nDistLeft = (hgroupTmp.width % nDistBestCurrent) / 2;
			while (nDistLeft > 0.4 * nDistBestCurrent) {
				nDistBestCurrent--;
				nDistLeft = (hgroupTmp.width % nDistBestCurrent) / 2;
			}
			nCurrentX = hgroupTmp.x + nDistLeft;
			rTmp = new Rectangle();
			while (nCurrentX < nXMax) {
				VProfilTmp = new VLine(null);
				VProfilTmp.t = hgroupTmp.y;
				VProfilTmp.b = hgroupTmp.y + hgroupTmp.height;
				VProfilTmp.x = nCurrentX;
				aTmp.push(VProfilTmp);
				nCurrentX += nDistBestCurrent;
			}
		}

		if (aTmp.length == 0) return;
		Sol50OnRoof.aVProfile = new Array();
		//sort by y
		// aTmp.sortOn("x", Array.NUMERIC);
		aTmp = _.sortBy(aTmp, 'x');

		iLen = aTmp.length;
		iCurrent = 0;
		while (iCurrent < iLen) {
			aCol = Sol50OnRoof.VProfile_getCol(aTmp, iLen, iCurrent);
			iCurrent += aCol.length;
			// aCol.sortOn("t", Array.NUMERIC);
			aCol = _.sortBy(aCol, 't');

			Sol50OnRoof.VProfile_optimize(aCol);
		}
		//correct length
		var nY: number;
		var nCnt: number;
		var nYDif: number;
		var nRoofHeight: number;
		nRoofHeight = RoofShape.getCurrentRoofHeight();
		for (i = 0; i < Sol50OnRoof.aVProfile.length; i++) {
			VProfilTmp = new VLine(Sol50OnRoof.aVProfile[i]);
			//extend profile to next purlin if the limit of cantilever is exceeded
			//top
			sRange = "f";
			nY = (VProfilTmp.t - Sol50OnRoof.nVPOverLapTop) - SC_Input.nBeamDist1;
			if (nY < 0) {
				nCnt = 0;
			} else {
				nCnt = Math.ceil(nY / SC_Input.nBeamDist);
			}
			nYDif = Math.abs(nY - (nCnt * SC_Input.nBeamDist));
			if (nYDif > Statics.oVerticalCantileverMax[sRange]) {
				//invalid
				if (nCnt > 0) {
					//beam exists
					nCnt--;
					VProfilTmp.t = (nCnt * SC_Input.nBeamDist) + SC_Input.nBeamDist1;
				} else {
					//no more beam to use
				}
			} else {
				//valid
			}
			//bottom
			sRange = "f";
			nY = (VProfilTmp.b + Sol50OnRoof.nVPOverLapBottom) - SC_Input.nBeamDist1;
			nCnt = Math.floor(nY / SC_Input.nBeamDist);
			nYDif = nY - (nCnt * SC_Input.nBeamDist);
			if (nYDif > Statics.oVerticalCantileverMax[sRange]) {
				//invalid
				nCnt++;
				nY = (nCnt * SC_Input.nBeamDist) + SC_Input.nBeamDist1;
				if (nY < nRoofHeight) {
					//beam exists
					VProfilTmp.b = nY;
				} else {
					//no more beam to use
				}
			} else {
				//valid
			}
			//correct by cover trim and vertical overlap
			VProfilTmp.t -= Sol50OnRoof.nVPOverLapTop;
			VProfilTmp.b += Sol50OnRoof.nVPOverLapBottom;
		}
	}
	//check for unwanted structures
	public static Purlin_VProfile_isOptimal(): boolean {
		var i: number;
		var bRet: boolean;
		var vprofileTmp: VLine;
		var nYLast: number = 1;//TFE
		if (SC_Input.iBeamType == SC_Beam.PURLIN) {
			Sol50OnRoof.Purlin_VProfile_find();
		} else {
			return true;
		}
		bRet = true;
		for (i = 0; i < Sol50OnRoof.aVProfile.length; i++) {
			vprofileTmp = new VLine(Sol50OnRoof.aVProfile[i]);
			if (i > 0) {
				if (nYLast != vprofileTmp.t) {
					bRet = false;
					break;
				}
			}
			nYLast = vprofileTmp.t;
		}
		return bRet;
	}
	//get amount
	public static getVProfile(): number {
		var i: number;
		var nSum: number;
		var iResult: number;
		var vprofilTmp: VLine;
		if (SC_Input.iBeamType == SC_Beam.PURLIN) {
			Sol50OnRoof.Purlin_VProfile_find();
		} else {
			Sol50OnRoof.VProfile_find();
		}
		nSum = 0;
		for (i = 0; i < Sol50OnRoof.aVProfile.length; i++) {
			vprofilTmp = Sol50OnRoof.aVProfile[i];
			nSum += vprofilTmp.b - vprofilTmp.t;
		}
		iResult = Math.ceil(nSum / Sol50OnRoof.nHProfileLen);
		return iResult;
	}
	
	// due to error
	//Abschlussblende, AbschBlend
	public static uiAbschBlendCol: number = 0xa36556;
	//in cm
	public static nAbschBlendHeight: number = 4.8;
	//Variable
	public static sAbschBlendVar: string;
	//Length
	public static nAbschBlendLen: number;
	//get amount
	public static getAbschBlend(): number {
		var i: number;
		var hprofilTmp: HLine;
		var iResult: number = 0;
		var nDif: number;
		var nSum: number;
		nSum = 0;
		for (i = 0; i < Sol50OnRoof.aHProfile.length; i++) {
			hprofilTmp = new HLine(Sol50OnRoof.aHProfile[i]);
			nDif = (hprofilTmp.r - hprofilTmp.l) - hprofilTmp.e;
			nSum += nDif;
		}
		nSum += nSum * Dyn.HP_PR_CO_FA;
		iResult = Math.ceil(nSum / Sol50OnRoof.nAbschBlendLen);
		return iResult;
	}

	//intersections
	//find intersections
	public static findIntersections(): any[] {
		var i: number;
		var j: number;
		var hprofilTmp: HLine;
		var vprofilTmp: VLine;
		var iResult: number = 0;
		var nDif: number;
		var nLeft: number;
		var nRight: number;
		var nY: number;
		var pTmp: Point;
		var aRet: any[] = new Array();
		// Sol50OnRoof.aVProfile.sortOn("x", Array.NUMERIC);
		const Sol50OnRoof_aVProfileol = _.sortBy(Sol50OnRoof.aVProfile, 'x');
		for (i = 0; i < Sol50OnRoof_aVProfileol.length; i++) {
			hprofilTmp = new HLine(Sol50OnRoof_aVProfileol[i]);
			nLeft = hprofilTmp.l;
			nRight = hprofilTmp.r;
			nY = hprofilTmp.y;
			for (j = 0; j < Sol50OnRoof_aVProfileol.length; j++) {
				vprofilTmp = new VLine(Sol50OnRoof_aVProfileol[j]);
				if (vprofilTmp.x < nRight) {
					if (vprofilTmp.x > nLeft) {
						if (vprofilTmp.t < nY && vprofilTmp.b > nY) {
							pTmp = new Point(vprofilTmp.x, nY);
							aRet.push(pTmp);
						}
					}
				} else {
					//no need to continue because the array was sorted by x
					break;
				}
			}
		}
		return aRet;
	}
	//roofhook
	public static uiRoofHookCol: string = '#d9e67c';
	//in cm
	public static nRoofHookSize: number = 15;
	//Variable big
	public static sRoofHookBigVar: string;
	//count big
	public static iRoofHookBigCount: number;
	//count small
	public static iRoofHookSmallCount: number;
	//set variable
	public static RoofHook_getString(): string {
		var sRet: string;
		Sol50OnRoof.RoofHook_getCnt();
		sRet = "";
		if (SC_Input.roofhookinputCurrent.iType == SC_RoofHook.TYPE_VARIO_DUO) {
			sRet += SC_Input.roofhookinputCurrent.sVarSuppShaftVarioDuo + ":" + (Sol50OnRoof.iRoofHookBigCount + Sol50OnRoof.iRoofHookSmallCount).toString() + "|";
		} else if (SC_Input.roofhookinputCurrent.iType == SC_RoofHook.TYPE_VARIO_SOLO) {
			sRet += SC_Input.roofhookinputCurrent.sVarSuppShaftVarioSolo + ":" + (Sol50OnRoof.iRoofHookBigCount + Sol50OnRoof.iRoofHookSmallCount).toString() + "|";
		}
		if (SC_Input.roofhookinputCurrent.iBasePlate == SC_RoofHook.BASE_PLATE_BIG) {
			sRet += SC_Input.roofhookinputCurrent.sVarBasePlateBig + ":" + (Sol50OnRoof.iRoofHookBigCount).toString() + "|";
		} else if (SC_Input.roofhookinputCurrent.iBasePlate == SC_RoofHook.BASE_PLATE_SMALL) {
			sRet += SC_Input.roofhookinputCurrent.sVarBasePlateSmall + ":" + (Sol50OnRoof.iRoofHookSmallCount).toString() + "|";
		} else if (SC_Input.roofhookinputCurrent.iBasePlate == SC_RoofHook.BASE_PLATE_MIXED) {
			sRet += SC_Input.roofhookinputCurrent.sVarBasePlateBig + ":" + (Sol50OnRoof.iRoofHookBigCount).toString() + "|";
			sRet += SC_Input.roofhookinputCurrent.sVarBasePlateSmall + ":" + (Sol50OnRoof.iRoofHookSmallCount).toString() + "|";
		}
		return sRet;
	}
	//get amount
	public static RoofHook_getCnt(): void {
		var iLen: number;
		var aIntersections: any[];
		aIntersections = Sol50OnRoof.findIntersections();
		iLen = aIntersections.length;
		if (iLen % 2 == 0) {
			Sol50OnRoof.iRoofHookBigCount = iLen / 2;
			Sol50OnRoof.iRoofHookSmallCount = iLen / 2;
		} else {
			Sol50OnRoof.iRoofHookBigCount = parseInt("" + Math.ceil(iLen / 2));
			Sol50OnRoof.iRoofHookSmallCount = parseInt("" + iLen / 2);
		}
		if (SC_Input.iBeamType == SC_Beam.RAFTER) {
			if (SC_Input.roofhookinputCurrent.iBasePlate == SC_RoofHook.BASE_PLATE_BIG) {
				Sol50OnRoof.iRoofHookBigCount = iLen;
				Sol50OnRoof.iRoofHookSmallCount = 0;
			} else if (SC_Input.roofhookinputCurrent.iBasePlate == SC_RoofHook.BASE_PLATE_SMALL) {
				Sol50OnRoof.iRoofHookBigCount = 0;
				Sol50OnRoof.iRoofHookSmallCount = iLen;
			} else if (SC_Input.roofhookinputCurrent.iBasePlate == SC_RoofHook.BASE_PLATE_MIXED) {
				//fit already
			}
		}
	}
	//Stockschrauben, StoSch
	//Variable Vertikalaufsatz
	public static sStoSchVeraufVar: string = "STOSCH_VERAUF";
	public static nStoSchVeraufVPE: number = 20;
	public static uiStoSchCol: string = '#d9e67c';
	//in cm
	public static nStoSchHeight: number = 15;
	//VPE
	public static nStoSchVPE: number;
	//list
	public static aStoSch: any[];
	//StoSch find
	public static StoSch_find(): void {
		var i: number;
		var j: number;
		var hprofilTmp: HLine;
		var vprofilTmp: VLine;
		var iResult: number = 0;
		var nDif: number;
		var nLeft: number;
		var nRight: number;
		var nY: number;
		var pTmp: Point;
		var aPurlin: any[];
		var nRoofHeight: number;
		var nRoofWidth: number;
		//Pfetten
		aPurlin = new Array();
		nY = SC_Input.nBeamDist1;
		nRoofHeight = RoofShape.getCurrentRoofHeight();
		nRoofWidth = RoofShape.getCurrentRoofWidth();
		while (nY <= nRoofHeight) {
			hprofilTmp = new HLine(null);
			hprofilTmp.l = 0;
			hprofilTmp.r = nRoofWidth;
			hprofilTmp.y = nY;
			aPurlin.push(hprofilTmp);
			nY += SC_Input.nBeamDist;
		}
		Sol50OnRoof.aStoSch = new Array();
		// Sol50OnRoof.aVProfile.sortOn("x", Array.NUMERIC);
		const Sol50OnRoof_aVProfileol = _.sortBy(Sol50OnRoof.aVProfile, 'x');
		for (i = 0; i < aPurlin.length; i++) {
			hprofilTmp = new HLine(aPurlin[i]);
			nLeft = hprofilTmp.l;
			nRight = hprofilTmp.r;
			nY = hprofilTmp.y;
			for (j = 0; j < Sol50OnRoof_aVProfileol.length; j++) {
				vprofilTmp = new VLine(Sol50OnRoof_aVProfileol[j]);
				if (vprofilTmp.x < nRight) {
					if (vprofilTmp.x > nLeft) {
						if (vprofilTmp.t < nY && vprofilTmp.b > nY) {
							pTmp = new Point(vprofilTmp.x, nY);
							Sol50OnRoof.aStoSch.push(pTmp);
						}
					}
				} else {
					//no need to continue because the array was sorted by x
					break;
				}
			}
		}
	}
	//get amount
	public static getStoSch(): number {
		var iLen: number;
		Sol50OnRoof.StoSch_find();
		iLen = Sol50OnRoof.aStoSch.length;
		return iLen;
	}
	//zeichnen
	public static drawStoSch(): void {
		var i: number, j: number;
		var StoSchTmp: Point;
		Sol50OnRoof.StoSch_find();
		for (i = 0; i < Sol50OnRoof.aStoSch.length; i++) {
			// StoSchTmp = new Point(Sol50OnRoof.aStoSch[i], null);
			// Global.pageDesign.canFramework.graphics.beginFill(Sol50OnRoof.uiStoSchCol);
			// Global.pageDesign.canFramework.graphics.drawRect(StoSchTmp.x - 7.5, StoSchTmp.y - 7.5, Sol50OnRoof.nStoSchHeight, Sol50OnRoof.nStoSchHeight);
			// Global.pageDesign.canFramework.graphics.endFill();
		}
	}
	public static drawStoSchPDF(): void {
		// var i: number, j: number;
		// var StoSchTmp: Point;
		// var rTmp: Rectangle = new Rectangle();
		// var nHalfHeight: number;
		// nHalfHeight = Sol50OnRoof.nStoSchHeight / 2;
		// Sol50OnRoof.StoSch_find();
		// for (i = 0; i < Sol50OnRoof.aStoSch.length; i++) {
		// 	StoSchTmp = Point(Sol50OnRoof.aStoSch[i]);
		// 	rTmp.x = (StoSchTmp.x - nHalfHeight) * this.SysPDF.nPdfFactor;
		// 	rTmp.y = (StoSchTmp.y - nHalfHeight) * this.SysPDF.nPdfFactor;
		// 	rTmp.width = Sol50OnRoof.nStoSchHeight * this.SysPDF.nPdfFactor;
		// 	rTmp.height = Sol50OnRoof.nStoSchHeight * this.SysPDF.nPdfFactor;
		// 	this.SysPDF.pdfMain.beginFill(new RGBColor(Sol50OnRoof.uiStoSchCol));
		// 	this.SysPDF.pdfMain.lineStyle(new RGBColor(0x000000), 0);
		// 	this.SysPDF.pdfMain.drawRect(rTmp);
		// 	this.SysPDF.pdfMain.endFill();
		// }
	}
	//Bohrschrauben "ALU/ALU Bohrschrauben 6,3x22 (VPE 100St.)", BohrSchr
	//Variable
	public static sDrillScrewVar: string = "";
	//VPE
	public static nDrillScrewVPE: number = 100;
	//Total count
	public static iDrillScrewTotal: number = 0;


	//get amount
	public static getDrillScrewCount(): number {
		var iResult: number = 0;
		var nFactor: number;
		var aIntersections: any[];
		if (Sol50OnRoof.sDrillScrewVar == "") {
			return 0;
		}
		if (SC_Input.iRoofType == RoofType.PANTILED) {
			nFactor = 4;
			iResult = (Sol50OnRoof.iRoofHookBigCount + Sol50OnRoof.iRoofHookSmallCount) * nFactor;
			iResult += Sol50OnRoof.getVVerb() * 2;
			iResult += Sol50OnRoof.getHVerb() * 2;
		} else if (SC_Input.iRoofType == RoofType.CORRUGATED) {
			nFactor = 2;
			aIntersections = Sol50OnRoof.findIntersections();
			iResult = aIntersections.length * nFactor;
			iResult += Sol50OnRoof.getVVerb() * 2;
			iResult += Sol50OnRoof.getHVerb() * 2;
			iResult += Sol50OnRoof.getStoSch() * nFactor;
		} else if (SC_Input.iRoofType == RoofType.TRAPEZOIDAL) {
			if (SC_Input.iMountingType == MountingType.CRISS_CROSS) {
				nFactor = 2;
				aIntersections = Sol50OnRoof.findIntersections();
				iResult = aIntersections.length * nFactor;
				iResult += Sol50OnRoof.getVVerb() * 2;
				iResult += Sol50OnRoof.getHVerb() * 2;
				iResult += Sol50OnRoof.getStoSch() * nFactor;
			} else if (SC_Input.iMountingType == MountingType.DIRECT) {
				// See corrosion protection's calculation
				iResult = 0;
			}
		} else if (SC_Input.iRoofType == RoofType.SLATED) {
			nFactor = 2;
			aIntersections = Sol50OnRoof.findIntersections();
			//intersections
			iResult = aIntersections.length * nFactor;
			//vertical connector
			iResult += Sol50OnRoof.getVVerb() * 2;
			//horizontal connector
			iResult += Sol50OnRoof.getHVerb() * 2;
			//screws
			iResult += aIntersections.length * 2;
		} else if (SC_Input.iRoofType == RoofType.PLAIN_TILED) {
			nFactor = 4;
			iResult = (Sol50OnRoof.iRoofHookBigCount + Sol50OnRoof.iRoofHookSmallCount) * nFactor;
			iResult += Sol50OnRoof.getVVerb() * 2;
			iResult += Sol50OnRoof.getHVerb() * 2;
		}
		return iResult;
	}
	public static getDrillScrewString(): string {
		var result: string = "";
		Sol50OnRoof.iDrillScrewTotal += Sol50OnRoof.getDrillScrewCount();
		if (Sol50OnRoof.iDrillScrewTotal > 0) {
			result = Sol50OnRoof.sDrillScrewVar + ":" + Math.ceil(Sol50OnRoof.iDrillScrewTotal / Sol50OnRoof.nDrillScrewVPE);
		}
		return result;
	}
	private static getDrillScrewRelated(): string {
		var result: string = "";
		// Initialize total amount
		Sol50OnRoof.iDrillScrewTotal = 0;
		result += Sol50OnRoof.getKabFanNetString();
		if (SC_Input.iMountingType == MountingType.DIRECT) {
			result += "|";
			result += Sol50OnRoof.getCorrosionProtectionString();
		}
		result += "|";
		result += Sol50OnRoof.getDrillScrewString();
		return result;
	}
	//Kabelfangnetz (PE), KabFanNet
	//Variable
	public static sKabFanNetVar: string = "";
	//Merkvariable: Bohrschraubenanzahl für Kabelfangnetz
	public static iKabFanNetBS: number;
	//get amount
	public static getKabFanNetCount(): number {
		var i: number;
		var hgroupTmp: HGroup;
		var result: number = 0;
		var nSum: number;
		if (Sol50OnRoof.sKabFanNetVar == "") {
			return 0;
		}
		nSum = 0;
		for (i = 0; i < Sol50OnRoof.aHGroups.length; i++) {
			hgroupTmp = new HGroup(Sol50OnRoof.aHGroups[i]);
			nSum += hgroupTmp.width;
		}
		result = Math.ceil(nSum / 1400);
		return result;
	}
	//get parameter string
	public static getKabFanNetString(): string {
		var result: string = "";
		var iKabFanNetCnt: number;
		iKabFanNetCnt = Sol50OnRoof.getKabFanNetCount();
		if (iKabFanNetCnt > 0) {
			result += Sol50OnRoof.sKabFanNetVar + ":" + iKabFanNetCnt.toString();
		}
		Sol50OnRoof.iDrillScrewTotal += iKabFanNetCnt * 20;
		return result;
	}
	//SOL-Guard-Modulschloss (VPE 1St.), SOLGuard
	//Variable
	public static sSOLGuardVar: string = "GUARD1";
	//get amount
	public static getSOLGuard(): number {
		var i: number;
		var hgroupTmp: HGroup;
		var iResult: number = 0;
		for (i = 0; i < Sol50OnRoof.aHGroups.length; i++) {
			hgroupTmp = new HGroup(Sol50OnRoof.aHGroups[i]);
			iResult += (hgroupTmp.iCnt + 1);
		}
		return iResult;
	}
	//Horizontal-Abschlusskappe, HAbKap
	//Variable
	public static sHAbKapVar: string;
	//get amount
	public static getHAbKap(): number {
		var iResult: number = 0;
		iResult = Math.ceil((Sol50OnRoof.aHProfile.length * 2) / 10);
		return iResult;
	}
	//Vertikal-Abschlusskappe, VAbKap
	//Variable
	public static sVAbKapVar: string;
	//VPE
	public static nVAbKapVPE: number = 10;
	//get amount
	public static getVAbKap(): number {
		var iResult: number = 0;
		var hgroupTmp: HGroup;
		var vlineTmp: VLine;
		var i: number;
		var j: number;
		var bHasPanelBelow: boolean;
		for (i = 0; i < Sol50OnRoof.aVProfile.length; i++) {
			vlineTmp = new VLine(Sol50OnRoof.aVProfile[i]);
			bHasPanelBelow = false;
			for (j = 0; j < Sol50OnRoof.aHGroups.length; j++) {
				hgroupTmp = new HGroup(Sol50OnRoof.aHGroups[j]);
				//y
				if (hgroupTmp.y + hgroupTmp.height < vlineTmp.b) {
					continue;
				}
				//x
				if ((hgroupTmp.x > vlineTmp.x) || (hgroupTmp.x + hgroupTmp.width < vlineTmp.x)) {
					continue;
				}
				var nDist: number;
				nDist = Math.abs(hgroupTmp.y - vlineTmp.b);
				if (nDist < 20) {
					bHasPanelBelow = true;
					break;
				}
			}
			if (!bHasPanelBelow) {
				iResult++;
			}
		}
		iResult = Math.ceil(iResult / Sol50OnRoof.nVAbKapVPE);
		return iResult;
	}
	//CorrosionProtection
	//Variable
	public static sCorrosionProtectionVar: string = "BITBAND1,5-100-10m";
	//VPE
	public static nCorrosionProtectionVPE: number = 300;
	//VPE in cm
	public static nBitBandVPE: number = 1000;
	//get amount
	public static getCorrosionProtectionString(): string {
		var result: string = "";
		var optimal_distance: number;
		var i: number;
		var profile_line: HLine;
		var profile_line_len: number;
		var drill_screw_count: number;
		var corrosion_protection_count: number;
		if (SC_Input.iMountingType != MountingType.DIRECT) {
			return "";
		}
		if (SC_Input.nHighBeadingDistance <= 22.5) {
			optimal_distance = SC_Input.nHighBeadingDistance * 2;
		} else {
			optimal_distance = SC_Input.nHighBeadingDistance;
		}
		drill_screw_count = 0;
		corrosion_protection_count = 0;
		for (i = 0; i < Sol50OnRoof.aHProfile.length; i++) {
			profile_line = new HLine(Sol50OnRoof.aHProfile[i]);
			profile_line_len = profile_line.r - profile_line.l;
			drill_screw_count += Math.ceil((profile_line_len / (optimal_distance) + 1) * 2);
			corrosion_protection_count += Math.ceil(profile_line_len / (SC_Input.nHighBeadingDistance) + 1);
		}
		result = Sol50OnRoof.sCorrosionProtectionVar + ":" + Math.ceil(corrosion_protection_count / Sol50OnRoof.nCorrosionProtectionVPE);
		Sol50OnRoof.iDrillScrewTotal += drill_screw_count;
		return result;
	}
	public static getCorrosionProtection_old(): number {
		var i: number;
		var iResult: number = 0;
		var nLen: number;
		if (SC_Input.iMountingType == MountingType.DIRECT) {
			//1/10
			nLen = ((Sol50OnRoof.getHProfile() * Sol50OnRoof.nHProfileLen) / 10);
			//pro Schraube 3,5 cm
			nLen += Sol50OnRoof.iKabFanNetBS * 3.5;
			iResult = Math.ceil(nLen / Sol50OnRoof.nBitBandVPE);
		}
		return iResult;
	}
	//Verbindungsbolzen - VA (VPE 50St.), VerbBolz
	//Variable
	public static sVerbBolzVar: string = "VERBBOLZEN50";
	//get amount
	public static getVerbBolz(): number {
		var iResult: number = 0;
		if (SC_Input.iMountingType == MountingType.DIRECT) {
			iResult = Math.ceil(((Sol50OnRoof.getHProfile() - 1) * 2) / 50);
		}
		return iResult;
	}
	//Horizontalverbinder PB 170mm, HVerb
	//Variable
	public static sHVerbVar: string = "";
	//get amount
	public static getHVerb(): number {
		var i: number;
		var iResult: number = 0;
		iResult = Sol50OnRoof.getHProfile() - 1;
		return iResult;
	}
	//Vertikalverbinder PB 170mm, VVerb
	//Variablef
	public static sVVerbVar: string = "";
	//get amount
	public static getVVerb(): number {
		var i: number;
		var iResult: number = 0;
		iResult = Sol50OnRoof.getVProfile() - 1;
		return iResult;
	}

	//VA-Erdungsset für Solargenerator, Erdbausatz
	//Variable
	public static sErdbausatzVar: string = "ERDSET1";
	//get amount
	public static getErdbausatz(): number {
		return Sol50OnRoof.Area_determine().length;
	}

	//Distanzadapter, DistAdap
	//Variable
	public static sDistAdapVar: string = "";
	//VPE
	public static nDistAdapVPE: number = 50;
	//get amount
	public static getDistAdap(): number {
		var i: number;
		var hgroupTmp: HGroup;
		var iResult: number = 0;
		for (i = 0; i < Sol50OnRoof.aHGroups.length; i++) {
			hgroupTmp = new HGroup(Sol50OnRoof.aHGroups[i]);
			if (hgroupTmp.nModWith > hgroupTmp.height) {
				iResult += (hgroupTmp.iCnt * 4) + 2;
			} else {
				iResult += (hgroupTmp.iCnt * 2) + 2;
			}
		}
		iResult = Math.ceil(iResult / Sol50OnRoof.nDistAdapVPE);
		return iResult;
	}
	public static getFastenComponents(): string {
		var iTmp: number;
		var sRes: string = "";
		if (SC_Input.iRoofType == RoofType.PANTILED) {
			sRes += Sol50OnRoof.RoofHook_getString();
		} else if (SC_Input.iRoofType == RoofType.CORRUGATED) {
			if (SC_Input.sStosch) {
				iTmp = Sol50OnRoof.getStoSch();
				sRes += Sol50OnRoof.sStoSchVeraufVar + ":" + ItemUtils.calculatePackingUnits(iTmp, this.nStoSchVeraufVPE).toString() + "|";
			}
		} else if (SC_Input.iRoofType == RoofType.TRAPEZOIDAL) {
			if (SC_Input.iMountingType == MountingType.CRISS_CROSS) {
				if (SC_Input.sStosch) {
					iTmp = Sol50OnRoof.getStoSch();
					sRes += Sol50OnRoof.sStoSchVeraufVar + ":" + ItemUtils.calculatePackingUnits(iTmp, this.nStoSchVeraufVPE).toString() + "|";
				}
			}
		} else if (SC_Input.iRoofType == RoofType.SLATED) {
			iTmp = Sol50OnRoof.findIntersections().length;
			sRes += "SLATE_DUMMY" + ":" + iTmp.toString() + "|";
			sRes += "HNGR_BLT_WD_130" + ":" + iTmp.toString() + "|";
			sRes += Sol50OnRoof.sStoSchVeraufVar + ":" + ItemUtils.calculatePackingUnits(iTmp, this.nStoSchVeraufVPE).toString() + "|";
		} else if (SC_Input.iRoofType == RoofType.PLAIN_TILED) {
			sRes += Sol50OnRoof.RoofHook_getString();
			iTmp = Sol50OnRoof.findIntersections().length;
			sRes += "PLAIN_TILE_BRICK" + ":" + iTmp.toString() + "|";
		}
		return sRes;
	}
	public static HProfile_setVar(): void {
		if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_4M) {

		} else if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_2M) {

		} else if (SC_Input.iMountSys == MountingSystem.SOL50_STAN_4M) {
			SOL50STANDARD4m.HProfile_setVar();
		}
	}
	public static HProfile_Stocklist_getString(): string {
		var sRes: string = "";
		if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_4M) {

		} else if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_2M) {

		} else if (SC_Input.iMountSys == MountingSystem.SOL50_STAN_4M) {
			sRes = SOL50STANDARD4m.HProfile_Stocklist_getString();
		}
		return sRes;
	}
	//Alle zusammen //commented due to error
	public static getAllInString(): string {
		var iTmp: number;
		var sRes: string = "";
		sRes += Sol50OnRoof.sHProfileVar + ":" + Sol50OnRoof.getHProfile() + "|";
		if (SC_Input.bBeam) {
			sRes += Sol50OnRoof.sHVerbVar + ":" + Sol50OnRoof.getHVerb() + "|";
			sRes += Sol50OnRoof.sVProfileVar + ":" + Sol50OnRoof.getVProfile() + "|";
			sRes += Sol50OnRoof.sVVerbVar + ":" + Sol50OnRoof.getVVerb() + "|";
			sRes += Sol50OnRoof.sVAbKapVar + ":" + Sol50OnRoof.getVAbKap() + "|";
			sRes += Sol50OnRoof.getFastenComponents();
		}
		sRes += Sol50OnRoof.getDrillScrewRelated() + "|";
		sRes += Sol50OnRoof.sVerbBolzVar + ":" + Sol50OnRoof.getVerbBolz() + "|";
		sRes += Sol50OnRoof.sAbschBlendVar + ":" + Sol50OnRoof.getAbschBlend() + "|";
		sRes += Sol50OnRoof.sSOLGuardVar + ":" + Sol50OnRoof.getSOLGuard() + "|";
		sRes += Sol50OnRoof.sHAbKapVar + ":" + Sol50OnRoof.getHAbKap() + "|";
		sRes += Sol50OnRoof.sErdbausatzVar + ":" + Sol50OnRoof.getErdbausatz() + "|";
		//SEN SOL-50 Rohrmanschette für Rohr 12-90mm
		if (SC_Input.iRoofType == RoofType.TRAPEZOIDAL) {
			iTmp = SC_Inv.getStrCnt();
			if (iTmp) {
				iTmp = Math.ceil(iTmp / 10);
				sRes += "ROHR_MANS_12_90:" + iTmp.toString() + "|";
			}
		}
		if (Sol50OnRoof.sDistAdapVar != "") {
			sRes += Sol50OnRoof.sDistAdapVar + ":" + Sol50OnRoof.getDistAdap() + "|";
		}
		// console.log("Sol50OnRoof.sDistAdapVar", Sol50OnRoof.sDistAdapVar);
		// console.log("Sol50OnRoof.getDistAdap()", Sol50OnRoof.getDistAdap());
		return sRes;
	}

	private static getRow(aMod: any[], iStart: number): any[] {
		var oMod: any;
		var oMod2: any;
		var aModResult: any[] = []; //TFE
		var i: number, j: number;
		var nYDif: number;
		if (aMod.length <= iStart) {
			return [];
		}
		oMod = aMod[iStart];
		j = 0;
		for (i = iStart + 1; i < aMod.length; i++) {
			oMod2 = aMod[i];  // Modul(aMod[i]);
			nYDif = oMod2.y - oMod.y;
			// trace("nYDif=" + nYDif + ", " + "oMod2.height=" + oMod2.height + ", " + "oMod.height=" + oMod.height);
			if (nYDif < Global.nModAbstTol && nYDif > -Global.nModAbstTol) {
				j++;
				//valid
			} else {
				break;
			}
		}
		aModResult = new Array(j);
		for (i = 0; i < j; i++) {
			aModResult[i] = aMod[i + iStart];
		}
		return aModResult;
	}
	private static getCol(aGroups: any[], iStart: number): any[] {
		var hgroupTmp: HGroup;
		var hgroupTmp2: HGroup;
		var aModResult: any[];
		var i: number, j: number;
		var nXDif: number;
		if (aGroups.length <= iStart) {
			// return null;
		}
		hgroupTmp = new HGroup(aGroups[iStart]);
		j = 1;
		for (i = iStart + 1; i < aGroups.length; i++) {
			hgroupTmp2 = new HGroup(aGroups[i]);
			nXDif = hgroupTmp2.x - hgroupTmp.x;
			if (nXDif < Global.nModAbstTol && nXDif > -Global.nModAbstTol) {
				j++;
				//valid
			} else {
				break;
			}
		}
		aModResult = new Array(j);
		for (i = 0; i < j; i++) {
			aModResult[i] = aGroups[i + iStart];
		}
		return aModResult;
	}
	//commented due to error //commented due to error
	private static getHGroup(aMod: any[], iStart: number): HGroup {
		var oMod: Modul;
		var oMod2: Modul;
		var hgroupResult: HGroup = new HGroup(null);//TFE
		var i: number, j: number;
		var nXDif: number;
		if (aMod.length <= iStart) {
			return hgroupResult;
		}
		oMod = aMod[iStart] ? aMod[iStart] : null; //new Modul(aMod[iStart], null);
		j = 1;
		for (i = iStart + 1; i < aMod.length; i++) {
			oMod2 = aMod[i];
			nXDif = oMod2.x - (oMod.x + oMod.width + Sol50.nHorizontalAbstand);
			if (nXDif < Global.nModAbstTol && nXDif > -Global.nModAbstTol && oMod.height == oMod2.height) {
				//valid
				j++;
			} else {
				break;
			}
			oMod = oMod2;
		}
		// oMod =new  Modul(aMod[iStart],null);
		hgroupResult = new HGroup(null);
		hgroupResult.iCnt = j;
		hgroupResult.nModWith = oMod.width;
		hgroupResult.height = oMod.height;
		hgroupResult.width = ((oMod.width + Sol50.nHorizontalAbstand) * j) - Sol50.nHorizontalAbstand;
		hgroupResult.x = oMod.x;
		hgroupResult.y = oMod.y;
		return hgroupResult;
	}
	//generate horizontal groups
	static generateHGroups(): void {
		var oMod: Modul;
		var oMod2: Modul;
		var aMod: any[];
		var aModRow: any[];
		var hgroupTmp: HGroup;
		var i: number, j: number, iInvalid: number;
		var iCurrent: number, iCurrent2: number;
		var iLen: number, iLen2: number;
		var sRange: string;
		var sModWidth: string;
		aMod = new Array();
		ModList.listOfModules.forEach((item: any) => {
			const temp = DrawRoofForPanel.layerPanel.find('#' + item.panelId)[0];
			if(temp) {
				item.y = temp.getAttrs().y;
				item.x = temp.getAttrs().x;
			}
			// need to remove added panel in ModList while group delete
		});
		Sol50OnRoof.aHGroups = new Array();
		Statics.bBadModulesExist = false;
		if (SC_Input.bBeam) {
			ModList.listOfModules.forEach((oMod: any) => {
				sRange = RoofShape.getAreaByModule(oMod);
				sModWidth = oMod.width + "";
				oMod.iCantilever = ModulProp.CANTILEVER_OFF;
				// if (Statics.oSpanWidthMax[sRange][sModWidth] == -1) {
				// 	oMod.iInvalid = ModulProp.INVALID_FULL;
				// 	Statics.bBadModulesExist = true;
				// } else {
				oMod.iInvalid = ModulProp.INVALID_NONE;
				aMod.push(oMod);
				// }
			});
		} else {
			ModList.listOfModules.forEach((oMod: any) => {
				oMod.iInvalid = ModulProp.INVALID_NONE;
				aMod.push(oMod);
			});
		}
		aMod = _.sortBy(aMod, 'y');
		iCurrent = 0;
		iLen = aMod.length;
		while (iCurrent < iLen) {
			aModRow = Sol50OnRoof.getRow(aMod, iCurrent);
			iCurrent++;
			iCurrent += aModRow.length;
			aModRow = _.sortBy(aModRow, 'x');
			iCurrent2 = 0;
			iLen2 = aModRow.length;
			while (iCurrent2 < iLen2) {
				hgroupTmp = Sol50OnRoof.getHGroup(aModRow, iCurrent2);
				iCurrent2 += hgroupTmp.iCnt;
				Sol50OnRoof.aHGroups.push(hgroupTmp);
			}
		}
		console.log(Sol50OnRoof.aHGroups)
	}
	//HGroups zeichnen  / /commented due to error
	private static drawHGroup(hgroupTmp: HGroup, _index: number = -1, _color: number = -1): void {
		var lblTmp: any; // Label;
		var nMax: number, nMin: number;
		if (_color == -1) {
			nMin = 0x000000;
			nMax = 0xffffff;
			_color = Math.floor(Math.random() * (nMax - nMin + 1)) + nMin;
		}
		// Global.pageDesign.canFramework.graphics.beginFill(_color, 0.5);
		// Global.pageDesign.canFramework.graphics.drawRect(hgroupTmp.x, hgroupTmp.y, hgroupTmp.width, hgroupTmp.height);
		// Global.pageDesign.canFramework.graphics.endFill();
		// if (_index != -1) {
		// 	lblTmp = new Label();
		// 	lblTmp.text = _index.toString();
		// 	lblTmp.x = hgroupTmp.x;
		// 	lblTmp.y = hgroupTmp.y;
		// 	lblTmp.width = 100;
		// 	lblTmp.setStyle("color", 0xffffff);
		// 	lblTmp.setStyle("fontSize", 40);
		// 	// Global.pageDesign.canFramework.addChild(lblTmp);
		// }
	}
	public static drawHGroups(): void {
		var i: number;
		var hgroupTmp: HGroup;
		// Global.pageDesign.canFramework.removeAllChildren();
		// Global.pageDesign.canFramework.graphics.clear();
		// Sol50OnRoof.aHGroups.sortOn("y", Array.NUMERIC);
		const Sol50OnRoof_aHGroups = _.sortBy(Sol50OnRoof.aHGroups, 'x');
		for (i = 0; i < Sol50OnRoof_aHGroups.length; i++) {
			hgroupTmp = new HGroup(Sol50OnRoof_aHGroups[i]);
			Sol50OnRoof.drawHGroup(hgroupTmp, i);
		}
	}
	//check horizontal distances of HGroup
	private static HGroup_check_HDistance(hgroupTmp1: HGroup, iStart: number, iLen: number): boolean {
		var nTop1: number, nBottom1: number;
		var nLeft1: number, nRight1: number;
		var nTop2: number, nBottom2: number;
		var nLeft2: number, nRight2: number;
		var hgroupTmp2: HGroup;
		nTop1 = hgroupTmp1.y;
		nBottom1 = hgroupTmp1.y + hgroupTmp1.height;
		nLeft1 = hgroupTmp1.x;
		nRight1 = hgroupTmp1.x + hgroupTmp1.width;
		for (; iStart < iLen; iStart++) {
			hgroupTmp2 = new HGroup(Sol50OnRoof.aHGroups[iStart]);
			nTop2 = hgroupTmp2.y;
			//				nBottom2 = hgroupTmp2.y + hgroupTmp2.height;
			nLeft2 = hgroupTmp2.x;
			nRight2 = hgroupTmp2.x + hgroupTmp2.width;
			if (nTop2 < nBottom1) {
				//x distance check
				if (nLeft2 > nLeft1) {
					if (nLeft2 - nRight1 < Sol50OnRoof.nGroupDistance) {
						RoofShape.drawHighlightH(nRight1, nTop1, nLeft2 - nRight1, hgroupTmp1.height);
						return false;
					}
				} else {
					if (nLeft1 - nRight2 < Sol50OnRoof.nGroupDistance) {
						RoofShape.drawHighlightH(nRight2, nTop1, nLeft1 - nRight2, hgroupTmp1.height);
						return false;
					}
				}
			} else {
				break;
			}
		}
		return true;
	}
	//check vertical distances of HGroup
	private static HGroup_check_VDistance(hgroupTmp1: HGroup, iStart: number, iLen: number): boolean {
		var nTop1: number, nBottom1: number;
		var nLeft1: number, nRight1: number;
		var nTop2: number, nBottom2: number;
		var nLeft2: number, nRight2: number;
		var hgroupTmp2: HGroup;
		var nYDif: number;
		nTop1 = hgroupTmp1.y;
		nBottom1 = hgroupTmp1.y + hgroupTmp1.height;
		nLeft1 = hgroupTmp1.x;
		nRight1 = hgroupTmp1.x + hgroupTmp1.width;
		for (; iStart < iLen; iStart++) {
			hgroupTmp2 = new HGroup(Sol50OnRoof.aHGroups[iStart]);
			nTop2 = hgroupTmp2.y;
			nBottom2 = hgroupTmp2.y + hgroupTmp2.height;
			nLeft2 = hgroupTmp2.x;
			nRight2 = hgroupTmp2.x + hgroupTmp2.width;
			if (nRight1 < nRight2) {
				nRight2 = nRight1;
			}
			if (nLeft2 < nRight1) {
				//y distance check
				if (nTop2 > nTop1) {
					nYDif = nTop2 - nBottom1;
					if (nYDif < Sol50OnRoof.nGroupDistance) {
						if (nYDif < Sol50.nVertikalAbstand - Global.nModAbstTol || nYDif > Sol50.nVertikalAbstand + Global.nModAbstTol) {
							RoofShape.drawHighlightV2(nRight2, nBottom1, 0, nYDif);
							return false;
						}
					}
				} else {
					nYDif = nTop1 - nBottom2;
					if (nYDif < Sol50OnRoof.nGroupDistance) {
						if (nYDif < Sol50.nVertikalAbstand - Global.nModAbstTol || nYDif > Sol50.nVertikalAbstand + Global.nModAbstTol) {
							RoofShape.drawHighlightV2(nRight2, nBottom2, 0, nYDif);
							return false;
						}
					}
				}
			} else {
				break;
			}
		}
		return true;
	}
	private static check_HGroups(): boolean {
		var hgroupTmp: HGroup;
		var i: number, j: number;
		var iLen: number;
		var bRet: boolean;
		iLen = Sol50OnRoof.aHGroups.length;
		bRet = true;
		if (iLen == 0) return bRet;
		//aHGroups was sorted by y
		for (i = 0; i < iLen; i++) {
			j = i + 1;
			if (j < iLen) {
				bRet = Sol50OnRoof.HGroup_check_HDistance(new HGroup(Sol50OnRoof.aHGroups[i]), j, iLen);
				if (!bRet) return false;
			}
		}
		//sort by x
		// Sol50OnRoof.aHGroups.sortOn("x", Array.NUMERIC);
		const Sol50OnRoof_aHGroups = _.sortBy(Sol50OnRoof.aHGroups, 'x');
		for (i = 0; i < iLen; i++) {
			j = i + 1;
			if (j < iLen) {
				bRet = Sol50OnRoof.HGroup_check_VDistance(new HGroup(Sol50OnRoof_aHGroups[i]), j, iLen);
				if (!bRet) return false;
			}
		}
		return bRet;
	}
	//Gruppen bilden
	public static createGroups(): void {
		if (ModList.iCount < 1) {
			//empty panel groups
			Sol50OnRoof.aHGroups = new Array();
			return;
		}
		Sol50OnRoof.generateHGroups();
		MountingSystem.bGroupsValid = Sol50OnRoof.check_HGroups();
	}
	
	private static Area_swapGroup(aGroupSrc: any[], aGroupDst: any[]): void {
		aGroupSrc.forEach((arearectTmp) => {
			arearectTmp.aGroup = aGroupDst;
			aGroupDst.push(arearectTmp);
		});
		// for each(var arearectTmp: AreaRect in aGroupSrc) {

		// }
		aGroupSrc.splice(0);
	}
	//commented due to error
	private static Area_findNextRow(aAreaRects: any[], arearectTmp1: AreaRect, iStart: number, iLen: number): void {
		var nTop1: number, nBottom1: number;
		var nLeft1: number, nRight1: number;
		var nTop2: number, nBottom2: number;
		var nLeft2: number, nRight2: number;
		var arearectTmp2: AreaRect;
		var nYDif: number;
		var nVDist: number;
		var nHDist: number;
		var j: number;
		nTop1 = arearectTmp1.y;
		nBottom1 = arearectTmp1.y + arearectTmp1.height;
		nLeft1 = arearectTmp1.x;
		nRight1 = arearectTmp1.x + arearectTmp1.width;
		nVDist = Sol50.nVertikalAbstand + Global.nModAbstTol;
		nHDist = Sol50.nHorizontalAbstand + Global.nModAbstTol;
		for (; iStart < iLen; iStart++) {
			arearectTmp2 = aAreaRects[iStart];
			nTop2 = arearectTmp2.y;
			nBottom2 = arearectTmp2.y + arearectTmp2.height;
			nLeft2 = arearectTmp2.x;
			nRight2 = arearectTmp2.x + arearectTmp2.width;
			nYDif = nTop2 - nBottom1;
			if (nYDif > nVDist) {
				break;
			} else if (nYDif > 0) {
				if (nLeft2 < nRight1 + nHDist && nRight2 + nHDist > nLeft1) {
					if (arearectTmp2.aGroup != null) {
						if (arearectTmp1.aGroup != arearectTmp2.aGroup) {
							//swap
							Sol50OnRoof.Area_swapGroup(arearectTmp1.aGroup, arearectTmp2.aGroup);
						}
						continue;
					} else {
						arearectTmp1.aGroup.push(arearectTmp2);
						arearectTmp2.aGroup = arearectTmp1.aGroup;
					}
					j = iStart + 1;
					if (j < iLen) {
						Sol50OnRoof.Area_findNextRow(aAreaRects, arearectTmp2, j, iLen);
					}
				}
			}
		}
	}
	private static Area_determine(): any[] {
		var hgroupTmp: HGroup;
		var i: number, j: number;
		var iLen: number;
		var aAreaRects: any[];
		var arearectTmp: AreaRect;
		var aGroup: any[];
		var aGroupList: any[];
		iLen = Sol50OnRoof.aHGroups.length;
		aGroupList = new Array();
		if (iLen == 0) return aGroupList;
		//copy
		aAreaRects = new Array();
		for (i = 0; i < iLen; i++) {
			hgroupTmp = new HGroup(Sol50OnRoof.aHGroups[i]);
			arearectTmp = new AreaRect();
			arearectTmp.x = hgroupTmp.x;
			arearectTmp.y = hgroupTmp.y;
			arearectTmp.width = hgroupTmp.width;
			arearectTmp.height = hgroupTmp.height;
			aAreaRects.push(arearectTmp);
		}
		//sort by y
		aAreaRects = _.sortBy(aAreaRects, 'y');
		for (i = 0; i < iLen; i++) {
			arearectTmp = aAreaRects[i];
			if (arearectTmp.aGroup != null) {
				continue;
			}
			aGroup = new Array();
			aGroup.push(arearectTmp);
			arearectTmp.aGroup = aGroup;
			j = i + 1;
			if (j < iLen) {
				Sol50OnRoof.Area_findNextRow(aAreaRects, arearectTmp, j, iLen);
			}
			if (aGroup.length > 0) {
				aGroupList.push(aGroup);
			}
		}
		return aGroupList;
	}

	public static showGroups(): void {
		var i: number;
		var aGroupTmp: any[];
		var nHeight: number;
		var sOut: string;
		var aGroupList: any[];
		aGroupList = Sol50OnRoof.Area_determine();
		sOut = "";
		for (i = 0; i < aGroupList.length; i++) {
			aGroupTmp = aGroupList[i];
			sOut += "-= Generatorfläche" + (i + 1).toString() + " =-" + "\n";
			sOut += "HGroups: " + aGroupTmp.length.toString() + "\n";
			sOut += "\n";
		}
		// Alert.show(sOut);
	}
	//Zuschnitt
	public static getZuschnitt(): string {
		var i: number;
		var iCnt: number;
		var hprofileTmp: HLine;
		var vprofileTmp: VLine;
		var nWidth: number;
		var nHeight: number;
		var nRest: number;
		var sOut: string;
		sOut = "";
		Sol50OnRoof.HProfile_find();
		for (i = 0; i < Sol50OnRoof.aHProfile.length; i++) {
			hprofileTmp = new HLine(Sol50OnRoof.aHProfile[i]);
			nWidth = hprofileTmp.r - hprofileTmp.l;
			iCnt = Math.floor(nWidth / Sol50OnRoof.nHProfileLen);
			if (nWidth - (iCnt * Sol50OnRoof.nHProfileLen) <= Sol50.nZuschnittTol) {
				iCnt--;
				nRest = Math.round(nWidth - (iCnt * Sol50OnRoof.nHProfileLen));
				sOut += Sol50OnRoof.sHProfileVar + ":" + nRest.toString() + ":" + (1).toString() + ":h|";
			} else {
				nRest = Math.round(nWidth - (iCnt * Sol50OnRoof.nHProfileLen));
				sOut += Sol50OnRoof.sHProfileVar + ":" + nRest.toString() + ":" + (1).toString() + ":h|";
			}
			if (iCnt > 0) {
				sOut += Sol50OnRoof.sHProfileVar + ":" + Sol50OnRoof.nHProfileLen.toString() + ":" + (iCnt).toString() + ":h|";
			}
		}
		if (SC_Input.bBeam) {
			if (SC_Input.iBeamType == SC_Beam.PURLIN) {
				Sol50OnRoof.Purlin_VProfile_find();
			} else {
				Sol50OnRoof.VProfile_find();
			}
			for (i = 0; i < Sol50OnRoof.aVProfile.length; i++) {
				vprofileTmp = new VLine(Sol50OnRoof.aVProfile[i]);
				nHeight = vprofileTmp.b - vprofileTmp.t;
				iCnt = Math.floor(nHeight / Sol50OnRoof.nVProfileLen);
				if (nHeight - (iCnt * Sol50OnRoof.nVProfileLen) <= Sol50.nZuschnittTol) {
					iCnt--;
					nRest = Math.round(nHeight - (iCnt * Sol50OnRoof.nVProfileLen));
					sOut += Sol50OnRoof.sVProfileVar + ":" + nRest.toString() + ":" + (1).toString() + ":v|";
				} else {
					nRest = Math.round(nHeight - (iCnt * Sol50OnRoof.nVProfileLen));
					sOut += Sol50OnRoof.sVProfileVar + ":" + nRest.toString() + ":" + (1).toString() + ":v|";
				}
				if (iCnt > 0) {
					sOut += Sol50OnRoof.sVProfileVar + ":" + Sol50OnRoof.nVProfileLen.toString() + ":" + (iCnt).toString() + ":v|";
				}
			}
		}
		return sOut;
	}
	//calculate outer rectangle
	public static getOuterRect(): Rectangle {
		var rRet: Rectangle;
		var i: number;
		var vprofileTmp: VLine;
		var nCurY: number;
		var hprofilTmp: HLine;
		rRet = new Rectangle();
		//HProfil
		Sol50OnRoof.HProfile_find();
		for (i = 0; i < Sol50OnRoof.aHProfile.length; i++) {
			hprofilTmp = new HLine(Sol50OnRoof.aHProfile[i]);
			if (i == 0) {
				rRet.left = hprofilTmp.l;
				rRet.right = hprofilTmp.r;
				rRet.top = hprofilTmp.y;
				rRet.bottom = hprofilTmp.y;
			} else {
				if (rRet.left > hprofilTmp.l) {
					rRet.left = hprofilTmp.l;
				}
				if (rRet.right < hprofilTmp.r) {
					rRet.right = hprofilTmp.r;
				}
				if (rRet.top > hprofilTmp.y) {
					rRet.top = hprofilTmp.y;
				}
				if (rRet.bottom < hprofilTmp.y) {
					rRet.bottom = hprofilTmp.y;
				}
			}
		}
		//extensions
		rRet.left -= Sol50OnRoof.nRandLeft;
		rRet.right += Sol50OnRoof.nRandRight;
		rRet.top -= Sol50OnRoof.nRandTop;
		rRet.bottom += Sol50OnRoof.nRandBottom;
		//VProfil
		if (SC_Input.bBeam) {
			if (SC_Input.iBeamType == SC_Beam.PURLIN) {
				Sol50OnRoof.Purlin_VProfile_find();
			} else {
				Sol50OnRoof.VProfile_find();
			}
			for (i = 0; i < Sol50OnRoof.aVProfile.length; i++) {
				vprofileTmp = new VLine(Sol50OnRoof.aVProfile[i]);
				if (rRet.top > vprofileTmp.t) {
					rRet.top = vprofileTmp.t;
				}
				if (rRet.bottom < vprofileTmp.b) {
					rRet.bottom = vprofileTmp.b;
				}
			}
		}
		return rRet;
	}
	/**
	 * collect information for each area
	 * - worst range of each area
	 * - left position
	 * @return
	 *
	 */
	private static Area_collectInformation(aGroupList: any[]): any[] {
		var rect: Rectangle;
		var sRange: string;
		var i: number;
		var j: number;
		var aGroupTmp: any[];
		var areaHLine: AreaRect;
		var aAreaInfo: any[];
		var ret: AreaInformation;
		var info: AreaInformation;
		var nLeft: number;
		var nRight: number;
		aGroupList = Sol50OnRoof.Area_determine();
		//rectangle buffer
		rect = new Rectangle();
		aAreaInfo = new Array();
		for (i = 0; i < aGroupList.length; i++) {
			nLeft = Number.MAX_VALUE;
			nRight = Number.MIN_VALUE;
			aGroupTmp = aGroupList[i];
			info = new AreaInformation();
			info.sRange = "h";
			info.hasPortrait = false;
			for (j = 0; j < aGroupTmp.length; j++) {
				areaHLine = <AreaRect>aGroupTmp[j];
				rect.left = areaHLine.x;
				rect.top = areaHLine.y;
				rect.height = areaHLine.height;
				rect.width = areaHLine.width;
				sRange = RoofShape.getRangeByRect(rect);
				if (nLeft > areaHLine.x) {
					nLeft = areaHLine.x;
				}
				if (nRight < areaHLine.x + areaHLine.width) {
					nRight = areaHLine.x + areaHLine.width;
				}
				if (info.sRange.charCodeAt(0) > sRange.charCodeAt(0)) {
					info.sRange = sRange;
				}
				//check for portrait panel alignment
				if (areaHLine.height > SC_Input.nModWidth) {
					info.hasPortrait = true;
				}
			}
			info.left = nLeft;
			info.right = nRight;
			aAreaInfo.push(info);
		}
		return aAreaInfo;
	}
	public static Purlin_VProfile_find(): void {
		var rect: Rectangle;
		var area_info: AreaInformation;
		var t: number;
		var i: number;
		var j: number;
		var aGroupTmp: any[];
		var aAreaList: any[];
		var areaHLine: AreaRect;
		var aAreaInfo: any[];
		var nVerticalSpace: number;
		// t = getTimer();
		//detect areas
		aAreaList = Sol50OnRoof.Area_determine();
		//rectangle buffer
		rect = new Rectangle();
		//worst ranges of each area
		aAreaInfo = Sol50OnRoof.Area_collectInformation(aAreaList);
		//
		Sol50OnRoof.aVProfile = new Array();
		for (i = 0; i < aAreaInfo.length; i++) {
			area_info = aAreaInfo[i];
			Sol50OnRoof.Purlin_VProfil_walkArea(aAreaList[i], area_info);
		}
		//correct length
		Sol50OnRoof.Purlin_VProfil_correctLength();
		//			trace((getTimer() - t) + "ms");
	}
	private static Purlin_VProfil_correctLength(): void {
		var nY: number;
		var nCnt: number;
		var nYDif: number;
		var nRoofHeight: number;
		var iBeamIndex: number;
		var nBeamPos1: number;
		var nBeamThickAdd: number = 5;
		var bExtended: boolean;
		var sRange: string;
		var nCantileverMax: number;
		var vprofileTmp: VLine;
		var i: number;
		nRoofHeight = RoofShape.getCurrentRoofHeight();
		sRange = "f";
		nCantileverMax = Statics.oVerticalCantileverMax[sRange];
		for (i = 0; i < Sol50OnRoof.aVProfile.length; i++) {
			vprofileTmp = new VLine(Sol50OnRoof.aVProfile[i]);
			//extend profile to next purlin if the limit of cantilever is exceeded
			//top
			bExtended = false;
			nY = vprofileTmp.t - SC_Input.nBeamDist1;
			if (nY < 0) {
				//first beam
			} else {
				iBeamIndex = parseInt("" + nY / SC_Input.nBeamDist) + 1;
				nBeamPos1 = (iBeamIndex * SC_Input.nBeamDist) + SC_Input.nBeamDist1;
				if (Math.abs(nBeamPos1 - vprofileTmp.t) > nCantileverMax) {
					vprofileTmp.t = (nBeamPos1 - SC_Input.nBeamDist) - nBeamThickAdd;
					bExtended = true;
				}
			}
			if (!bExtended) {
				//correct by cover trim and vertical overlap
				vprofileTmp.t = vprofileTmp.t - Sol50OnRoof.nVPOverLapTop;
			}
			//bottom
			bExtended = false;
			if (vprofileTmp.b > RoofShape.getCurrentRoofHeight() - SC_Input.nBeamDist2) {
				//last beam
			} else {
				nY = vprofileTmp.b - SC_Input.nBeamDist1;
				iBeamIndex = parseInt("" + nY / SC_Input.nBeamDist);
				nBeamPos1 = (iBeamIndex * SC_Input.nBeamDist) + SC_Input.nBeamDist1;
				if (Math.abs(vprofileTmp.b - nBeamPos1) > nCantileverMax) {
					vprofileTmp.b = (nBeamPos1 + SC_Input.nBeamDist) + nBeamThickAdd;
					bExtended = true;
				}
			}
			if (!bExtended) {
				//correct by cover trim and vertical overlap
				vprofileTmp.b += Sol50OnRoof.nVPOverLapBottom;
			}
		}
	}
	private static Purlin_VProfil_walkArea(aHLines: any[], area_info: AreaInformation): void {
		var i: number;
		var j: number;
		var nX: number;
		var nXMax: number;
		var nSpanMax: number;
		var nCantileverMax: number;
		var nCurrent: number;
		var aTmp: any[];
		var vprofileTmp: VLine;
		var areaHLine: AreaRect;
		var nVSpace: number;
		aTmp = new Array();
		nSpanMax = Number.MAX_VALUE;
		//max row height
		if (area_info.hasPortrait) {
			nVSpace = SC_Input.nModHeight;
		} else {
			nVSpace = SC_Input.nModWidth;
		}
		nSpanMax = 1; // Statics.oSpanWidthMax[area_info.sRange][nVSpace.toString()];
		nCantileverMax = nSpanMax * Statics.CANTILEVER_MAX_FACTOR;
		//find optimal start x
		var iFromStartCnt: number, iFromMiddleCnt: number, iFromEndCnt: number;
		iFromStartCnt = iFromMiddleCnt = iFromEndCnt = 0;
		for (i = 0; i < aHLines.length; i++) {
			areaHLine = <AreaRect>aHLines[i];
			var nTmp: number;
			//from start of cantilever
			nTmp = nSpanMax - ((areaHLine.x - area_info.left) % nSpanMax);
			if (nTmp <= nCantileverMax) {
				iFromStartCnt++;
			}
			//from middle of cantilever
			nTmp = nSpanMax - (((areaHLine.x + (nCantileverMax * 0.5)) - area_info.left) % nSpanMax);
			if (nTmp <= nCantileverMax) {
				iFromMiddleCnt++;
			}
			//from end of cantilever
			nTmp = nSpanMax - (((areaHLine.x + nCantileverMax) - area_info.left) % nSpanMax);
			if (nTmp <= nCantileverMax) {
				iFromEndCnt++;
			}
		}
		var iMax: number;
		var nCantileverFirst: number;
		if (iFromMiddleCnt >= iFromStartCnt) {
			iMax = iFromMiddleCnt;
			nCantileverFirst = nCantileverMax * 0.5;
		} else {
			iMax = iFromStartCnt;
			nCantileverFirst = 0;
		}
		if (iFromEndCnt >= iMax) {
			if (iFromEndCnt > iFromMiddleCnt) {
				nCantileverFirst = nCantileverMax;
			}
		}
		nX = area_info.left + nCantileverFirst;
		for (i = 0; i < aHLines.length; i++) {
			areaHLine = <AreaRect>aHLines[i];
			nXMax = areaHLine.x + areaHLine.width;
			if (nX > areaHLine.x) {
				nTmp = areaHLine.x - (nX - nSpanMax);
			} else {
				nTmp = areaHLine.x - nX;
			}
			var nStart: number;
			nStart = nCurrent = areaHLine.x + (nSpanMax - (nTmp % nSpanMax));
			while (nCurrent < nXMax) {
				vprofileTmp = new VLine(null);
				vprofileTmp.t = areaHLine.y;
				vprofileTmp.b = areaHLine.y + areaHLine.height;
				vprofileTmp.x = nCurrent;
				aTmp.push(vprofileTmp);
				nCurrent += nSpanMax;
			}
			//left
			if (nStart - areaHLine.x > nCantileverMax) {
				vprofileTmp = new VLine(null);
				vprofileTmp.t = areaHLine.y;
				vprofileTmp.b = areaHLine.y + areaHLine.height;
				vprofileTmp.x = areaHLine.x + nCantileverMax * 0.5;
				aTmp.push(vprofileTmp);
			}
			//right
			if (nSpanMax - (nCurrent - nXMax) > nCantileverMax) {
				vprofileTmp = new VLine(null);
				vprofileTmp.t = areaHLine.y;
				vprofileTmp.b = areaHLine.y + areaHLine.height;
				vprofileTmp.x = nXMax - nCantileverMax * 0.5;
				aTmp.push(vprofileTmp);
			}
		}
		if (aTmp.length == 0) return;
		//sort by x
		// aTmp.sortOn("x", Array.NUMERIC);
		aTmp = _.sortBy(aTmp, 'x');
		var iLen: number = aTmp.length;
		var iCurrent: number = 0;
		var aCol: any[];
		while (iCurrent < iLen) {
			aCol = Sol50OnRoof.VProfile_getCol(aTmp, iLen, iCurrent);
			iCurrent += aCol.length;
			// aCol.sortOn("t", Array.NUMERIC);
			aCol = _.sortBy(aCol, 'x');

			Sol50OnRoof.VProfile_optimize(aCol);
		}
	}
}
// }
